import busRoute from '../../../../../../../../assets/images/icons/busRoute.svg';
import ferry from '../../../../../../../../assets/images/icons/ferry.svg';
import subway from '../../../../../../../../assets/images/icons/subway.svg';
import train from '../../../../../../../../assets/images/icons/train.svg';
import walk from '../../../../../../../../assets/images/icons/walk.svg';
import floatToCurrency from '../../../../../../../../utils/floatToCurrency';
import OpacityAnimation from '../../../../../../../OpacityAnimation';
import { TrajetoSelecaoIda, TrajetoSelecaoVolum, ValeTransp } from '../../../../../../types';
import { ViewType } from '../../types';
import { Container, Distance, DistanceTime, IconContainer, InstructionGroup, Instructions, Price, StepDescription, StepTitle, TicketDescription, TicketGroup, TicketInfo, TicketTotal, Time, Title, TotalContainer } from './styles';

interface IRoute {
  goingRoute: TrajetoSelecaoIda[];
  returningRoute: TrajetoSelecaoVolum[];
  view: ViewType;
  tickets: ValeTransp[];
  totalVt: number;
}

export default function Route({ goingRoute, returningRoute, view, tickets, totalVt }: IRoute) {
  const iconsMap: { [key: string]: string } = {
    Caminhada: walk,
    Trem: train,
    Ônibus: busRoute,
    Metrô: subway,
    Fretado: busRoute,
    Fluvial: ferry,
    Integração: busRoute,
  };

  return (
    <Container>
      {view === 'going' && (
        <OpacityAnimation delay={0.15}>
          {goingRoute.map((routeData) => (
            <InstructionGroup key={Math.random() + routeData.distanciaTj}>
              <IconContainer>
                <img src={iconsMap[routeData.tipoTransp]} alt="" className='sameAsTheme' />
              </IconContainer>

              <Instructions>
                {routeData.letreiroTransporte === 'TRANSPORTE MANTIDO' ? (
                  <StepTitle>
                    {routeData.letreiroTransporte}
                  </StepTitle>
                ) : (
                  <>
                    <StepTitle>
                      {routeData.tipoTransp === 'Caminhada'
                        ? 'Caminhe'
                        : routeData.descricaoCaminhada}
                    </StepTitle>

                    <StepDescription>
                      {routeData.tipoTransp === 'Caminhada'
                        ? (
                          <div>
                            {`De ${routeData.origemCaminhada} até ${routeData.destinoCaminhada}`}
                          </div>
                        )
                        : (
                          <>
                            <div className="transport">
                              {`${routeData.operadora} ${routeData.letreiroTransporte}`}
                            </div>
                            <div>
                              {`Em ${routeData.embarque} e viaje até ${routeData.desembarque}`}
                            </div>
                          </>
                        )}
                    </StepDescription>

                    <DistanceTime>
                      {routeData.tipoTransp !== 'Caminhada' && (
                        <Price>{floatToCurrency(routeData.valorBilTrecho)}</Price>
                      )}
                      <Distance>{`${routeData.distanciaTj}m`}</Distance>
                      <Time>{`${routeData.tempoTj}min`}</Time>
                    </DistanceTime>
                  </>
                )}
              </Instructions>
            </InstructionGroup>
          ))}
        </OpacityAnimation>
      )}

      {view === 'returning' && (
        <OpacityAnimation delay={0.15}>
          {returningRoute.map((routeData) => (
            <InstructionGroup key={Math.random() + routeData.distanciaTj}>
              <IconContainer>
                <img src={iconsMap[routeData.tipoTransp]} alt="" />
              </IconContainer>

              <Instructions>
                {routeData.letreiroTransporte === 'TRANSPORTE MANTIDO' ? (
                  <StepTitle>
                    {routeData.letreiroTransporte}
                  </StepTitle>
                ) : (
                  <>
                    <StepTitle>
                      {routeData.tipoTransp === 'Caminhada'
                        ? 'Caminhe'
                        : routeData.descricaoCaminhada}
                    </StepTitle>

                    <StepDescription>
                      {routeData.tipoTransp === 'Caminhada'
                        ? (
                          <div>
                            {`De ${routeData.origemCaminhada} até ${routeData.destinoCaminhada}`}
                          </div>
                        )
                        : (
                          <>
                            <div className="transport">
                              {`${routeData.operadora} ${routeData.letreiroTransporte}`}
                            </div>
                            <div>
                              {`Em ${routeData.embarque} e viaje até ${routeData.desembarque}`}
                            </div>
                          </>
                        )}
                    </StepDescription>

                    <DistanceTime>
                      {routeData.tipoTransp !== 'Caminhada' && (
                        <Price>{floatToCurrency(routeData.valorBilTrecho)}</Price>
                      )}
                      <Distance>{`${routeData.distanciaTj}m`}</Distance>
                      <Time>{`${routeData.tempoTj}min`}</Time>
                    </DistanceTime>
                  </>
                )}
              </Instructions>
            </InstructionGroup>
          ))}
        </OpacityAnimation>
      )}

      {view === 'tickets' && (
        <OpacityAnimation delay={0.15}>
          {tickets.map((ticket) => (
            <TicketGroup key={`${ticket.codOperadora}${ticket.codVT}${ticket.qtdVt}${ticket.tipoTransp}`}>
              <IconContainer logo>
                <img src={ticket.linkOPLogo} alt="opLogo" className="noBg" />
              </IconContainer>

              <TicketInfo>
                {ticket.codVT === 1758 ? (
                  <Title>
                    Transporte Mantido
                  </Title>
                ) : (
                  <>
                    <Title>
                      {ticket.qtdVt}
                      x
                      {' '}
                      {ticket.operadora}
                    </Title>

                    <TicketDescription>
                      {floatToCurrency(ticket.tarifaVt)}
                      {' '}
                      -
                      {' '}
                      {ticket.tipoTransp}
                    </TicketDescription>

                    <TicketTotal>
                      Total de
                      {' '}
                      {floatToCurrency(ticket.totVt)}
                    </TicketTotal>
                  </>
                )}
              </TicketInfo>
            </TicketGroup>
          ))}

          <TotalContainer>
            VT Total por dia
            {' '}
            {floatToCurrency(totalVt)}
          </TotalContainer>
        </OpacityAnimation>
      )}
    </Container>
  );
}
